export const CREATE_GRID = 'CREATE_GRID'
export const FILL_BLOCK = 'FILL_BLOCK'
export const SELECT_BLOCK = 'SELECT_BLOCK'
